import { Modal } from "antd";

import { NewFiscalDocForm } from "components";
import { useCreateFiscalDoc } from "services/tax-retentions.service";

import { INIT_VALUES_NEW_RETENTION_RAPPI } from "constants/rappi";

import type { ItfTaxpayer } from "types/taxpayers";
import type { ItfNewFiscalDocIssuance } from "types/taxes";

export interface Props {
  show: boolean;
  taxpayer: Partial<ItfTaxpayer>;
  onClose?: () => void;
  issuedBy?: string;
  isRetention?: boolean;
}

export function NewFiscalDocIssuance(props: Props): JSX.Element {
  const { taxpayer, show, onClose = () => undefined, issuedBy = "rappi", isRetention = true } = props;
  const isRetentionByRappi = isRetention && issuedBy === "rappi";

  const createFiscalDoc = useCreateFiscalDoc();

  const theInitValues = (): Partial<ItfNewFiscalDocIssuance> => {
    const init = isRetentionByRappi ? INIT_VALUES_NEW_RETENTION_RAPPI : {};
    return {
      ...init,
      taxpayer_id: taxpayer.id,
    };
  };

  const handleOnSubmit = (values): void => createFiscalDoc.mutate({ taxpayerId: taxpayer.id, body: values });

  if (!taxpayer?.id) return null;

  return (
    <Modal
      title="Emitir nuevo certificado de retención"
      visible={show}
      centered={true}
      destroyOnClose={true}
      onCancel={onClose}
      footer={null}
      confirmLoading={createFiscalDoc.isLoading}
    >
      <NewFiscalDocForm
        nameForm="create-fiscal-doc"
        textSubmit="Emitir"
        loading={createFiscalDoc.isLoading}
        initialValues={theInitValues()}
        resetFields={createFiscalDoc.isSuccess}
        hiddenSomeFields={isRetentionByRappi}
        handleOnSubmit={handleOnSubmit}
      />
    </Modal>
  );
}
